// File: frontend/src/views/public/Products.js

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { INSURANCE_PRODUCTS } from '../../config/insuranceProducts';
import ScrollAnimation from '../../components/common/ScrollAnimation';
import PageContainer from '../../components/layout/PageContainer';
import styles from './Products.module.css';
import SEO from '../../components/utility/SEO';
import { SEO_CONFIG } from '../../config/seo';

const Products = () => {
  const navigate = useNavigate();
  const seo = SEO_CONFIG.products;

  const products = Object.values(INSURANCE_PRODUCTS);

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        canonical={seo.canonical}
        image={seo.image}
      />
      <PageContainer>
        <div className={styles.page}>
          {/* Hero */}
          <section className={styles.hero}>
            <ScrollAnimation>
              <h1 className={styles.heroTitle}>
                Upload Any Insurance Policy
              </h1>
              <p className={styles.heroSubtitle}>
                We support all major insurance types. Upload your policy and get instant insights on coverage, gaps, and claims guidance.
              </p>
            </ScrollAnimation>
          </section>

          {/* Products Grid */}
          <section className={styles.section}>
            <div className={styles.grid}>
              {products.map((product, index) => {
                const IconComponent = product.icon;
                return (
                  <ScrollAnimation key={product.id} delay={index * 50}>
                    <div
                      className={styles.productCard}
                      onClick={() => navigate(`/products/${product.slug}`)}
                    >
                      <div className={styles.productIcon}>
                        <IconComponent size={32} strokeWidth={2} />
                      </div>
                      <h3 className={styles.productName}>{product.name}</h3>
                      <p className={styles.productDescription}>
                        {product.heroSubtitle}
                      </p>
                      <button className={styles.productButton}>
                        Learn More
                        <ArrowRight size={16} strokeWidth={2.5} />
                      </button>
                    </div>
                  </ScrollAnimation>
                );
              })}
            </div>
          </section>
        </div>
      </PageContainer>
    </>
  );
};

export default Products;